// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container__1JBvc","list":"main_list__20N4Z","tit":"main_tit__11lYx","lis":"main_lis__1OjWd"};